import React, {Component} from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons'
import { sensorTypeName } from './Sensors';
import SecondServer from '../../database/SecondServer'
import {newSortIndicators, clickToTableTarget, clickToNamedClass, formatTable,
        flipSort, flipIndicator} from "../RenderHelpers";
import DeviceEdit from '../Controls/DeviceEdit'
import { siteAccessCode } from '../../database/apiv2SiteAccessor';
import NoResults from '../../Alert/NoResults'
import Search from '../../Search/Search'
import FilterRender from '../../Search/FilterRender'
import {nestedProp, } from '../../Utils/object'
import Checkbox, {initCheckboxen} from '../../Edit/Checkbox'
import {MeterTypeDisplay} from '../Controls/MeterDropdown'
import {UnitsDisplay} from '../Controls/UnitsDropdown'
import { StyleDisplay } from '../Controls/StyleDropdown';
import Popup from '../../Alert/Popup'
import GridAction from '../Controls/GridAction'
import {TryAgain} from '../../Alert/CommonNotices'
import { isTransceiverRadio } from '../Model/DeviceType'
import { cachedPerms, canWrite } from "../../Overview/SitePerms"
import MeterMassEdit from "./MeterMassEdit"
import { urlSensorInfo } from '../../database/apiUrls';
import { InitSensorTypes } from './MeterTypes';
import SensorTypeDropdown from './SensorTypeDropdown'
import { getIcons, nameToIcon } from "../Controls/DeviceIcons";

// available reports
import jsonReportCfg from '../reportcfg';
import '../report.css'
import './Measure.css'
import '../Controls/buttonbar.css'
import '../../Decorators/Checkmarks.css'
import "../ConfigSensor.css"
import { renderLoader } from '../../Loading/loading';
import { getBigConfig, readBigConfig } from '../../Sites/SiteConfig';

export default class Meter extends Component {
  constructor(props) {
    super(props);

    //this.reportId = this.props.location.pathname.split("/").pop();
    this.reportId = "measure";
    this.arrSort = newSortIndicators(jsonReportCfg.data[this.reportId].displayOrder.length);
    this.tableId = "dispTable";   //not changeable at run time
    this.deviceEditMap = [{from: "apt" , to: "apt"}, 
      {from: "building" , to:"building" }, {from: "node_id", to: "node_id"},
      {from: "location_note", to:"location_note"}, {from: "address", to: "address"}]
    this.ss = new SecondServer(props)
    this.dlgTitle = ""
    this.sensorTypes = []

    this.state = {
      report: [],
      filterReport: null,
      formatReport: null,
      siteDetails: null,
      errorMsg: null,
      lastSort: '', 
      colSort: this.arrSort,
      batteryFormat: 0,
      isLoading: true,
      loader: renderLoader(),
      arrCheckboxes: [],
      titleCheckbox: false,
      importNow: false,
      editModal: false,
      deviceToEdit: undefined,
      swapModal: false,
      activeSensor: "Pulse Totalizer 1",
      activeType: undefined,
      massShow: false,
      massData: []
    };
    this.deviceStatus = undefined;
    this.sort = this.sort.bind(this);
    this.parentUpdate = this.parentUpdate.bind(this);
    this.checkEmAll = this.checkEmAll.bind(this);
    this.titleRowCheckbox = this.titleRowCheckbox.bind(this);
    this.onMassEdit = this.onMassEdit.bind(this);
    this.rowCheck = this.rowCheck.bind(this);
    this.refresh = this.refresh.bind(this)
    this.confirmed = this.confirmed.bind(this)
    this.onEdit = this.onEdit.bind(this)
    this.onEditHide = this.onEditHide.bind(this)
    this.massClick = this.massClick.bind(this)
    this.selectClick = this.selectClick.bind(this)
    this.massOver = this.massOver.bind(this)
    this.sensorTypeClick = this.sensorTypeClick.bind(this)
  }

  async fetchData() {
    if (!this.state.isLoading) 
      this.setState({isLoading: true});

    const site = this.props.getActiveSite();
    if (!this.deviceStatus) {
      const pr1 = getIcons ({...this.props, ss: this.ss, ac: siteAccessCode(site)})
      pr1.then((result) => {this.deviceStatus = result?.data})
    } 
    const url = await getBigConfig(this.props, this.ss, this.cancelPoll)
    const json = await readBigConfig (url, this.cancelPoll)
    //console.log (json)
    //console.log (resp.jsonResponse.data)
    //return resp?.jsonResponse?.data
    return json
  }

  setData(filteredResponse) {
    if (filteredResponse?.devices) {
      const devices = filteredResponse.devices.filter(i=>i?.type!=='RPMT')
      this.sortData(devices, "device_id")
      this.mergeApiIcons(devices)
      const displayCopy = devices.slice();
      const formatCopy = formatTable (displayCopy, "device_id", this.props.radioStyle);
      const chkbox = initCheckboxen(displayCopy.length)
      this.setState( {report: devices, filterReport: displayCopy, formatReport: formatCopy,
        siteDetails:filteredResponse?.site_details, arrCheckboxes: chkbox} );
      this.sensorTypes = InitSensorTypes(formatCopy)
      if (this.sensorTypes) {
        this.initSensorState()
      }
    }
    this.setState({isLoading: false})
  }
  mergeApiIcons (dispData) {
    const status = this.deviceStatus?.icons
    if (status) {
      dispData.forEach (i=> 
        i.apiIcon = status.find(s=>s.device_id.toUpperCase() === i.device_id.toUpperCase())?.icon)  
    }
  }

  async componentDidMount() {
    const site = this.props.getActiveSite()
    if (site?.site_details?.devices) {
      this.setData (site.site_details)
    }
    else 
      await this.refresh()

    if (!this.deviceStatus) {
      const pr1 = getIcons ({...this.props, ss: this.ss, ac: siteAccessCode(site)})
      pr1.then((result) => {
        this.deviceStatus = result?.data
        this.mergeApiIcons(this.state.formatReport)
        this.mergeApiIcons(this.state.filterReport)
        this.setState ({importNow: !this.state.importNow})
      })
    }
   }
  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.radioStyle !== this.props.radioStyle) {
      this.setData(this.state.report)
    }
    if (this.props?.update && prevProps.update < this.props.update)
      this.componentDidMount()
    if (this.props?.sensor && this.props.sensor !== prevProps?.sensor)
      this.initSensorState()
  }
  initSensorState() {
    if (this.sensorTypes) {
      const index = this.sensorTypes.indexOf(this.props?.sensor)
      const sensorIndex = index > -1 ? index : 0
      this.setState({activeType: this.sensorTypes[sensorIndex], 
        activeSensor:sensorTypeName(this.sensorTypes[sensorIndex])})  
    }
  }
  async refresh (){
    const filteredResponse = await this.fetchData();
    this.setData(filteredResponse);
  }
  fillEnabledCheckboxen (state) {
    const temp = this.state.arrCheckboxes.map((box, index) => this.sensorSelectable(index) ? state : box)
    this.setState({arrCheckboxes: temp, titleCheckbox: state}) 
  }
  checkEmAll() {
    const newstate = !this.state.titleCheckbox;
    this.fillEnabledCheckboxen (newstate)
  }
  titleRowCheckbox () {
    const props = {
      selected:  this.state.titleCheckbox,
      label: "",  name: "checkall", parentIndex: null,
      parentData: this.checkEmAll
    };
    return <th className="csv-td" key="trCheck"><Checkbox {...props}/></th>
  }

  rowCheck (state, index) {
    let temp = this.state.arrCheckboxes;
    temp[index] = state;
    this.setState({arrCheckboxes : temp })
  }
 
  gridCheck(props) {
    return <td className="csv-td" key="checkOne" id={props.index}>
      <Checkbox parentData={this.rowCheck} {...props} /></td>
  }

  //click handler for title row
  sort(e) {
    const targ = clickToTableTarget(e);
    if (jsonReportCfg.data[this.reportId]?.sortable[targ.cellIndex] === false) 
      return;
    if ("id" in targ) {
      const column = targ.id.trim();
      const arrSort = flipIndicator (targ, this.state.colSort, this.state.lastSort)
      flipSort(this.state.filterReport, column, this.state.lastSort)
      const display = formatTable (this.state.filterReport, "device_id", this.props.radioFormat());
      this.setState ({formatReport: display, lastSort: column, colSort: arrSort});
    }
  }
  sortData (devices, column) {
    devices.sort(function(a,b) {
      let x = nestedProp(a, column) ?? ''
      let y = nestedProp(b, column) ?? ''
      if (typeof x === 'number') return (x-y);
      return x.localeCompare(y);
    });
  }

  transformSearch = (item, key, usearch) =>{
    switch (key) {
      case "sensors.0.sensor_type":
      case "sensors.1.sensor_type":
        return (sensorTypeName(nestedProp(item, key))??'').toUpperCase().indexOf(usearch) > -1
      case 'sensors.0.meter_type': 
      case 'sensors.1.meter_type':
        return MeterTypeDisplay(nestedProp(item, key)).toUpperCase().indexOf(usearch) > -1
      case 'sensors.0.units':
      case 'sensors.1.units':
        return UnitsDisplay(nestedProp(item, key)).toUpperCase().indexOf(usearch) > -1
      case 'sensors.0.meter_style':
      case 'sensors.1.meter_style':
        return StyleDisplay(nestedProp(item, key)).toUpperCase().indexOf(usearch) > -1
      default:
        return (nestedProp(item, key)??'').toUpperCase().indexOf(usearch) > -1
    }
  }
  filterable = ["type", "device_id", "node_id", "building", "apt", "sensors.0.meter_type",
                      "sensors.0.units", "sensors.0.sensor_type", "sensors.0.meter_style", 
                      "sensors.0.factor", "sensors.0.initial_meter_read",
                      "sensors.1.meter_type",
                      "sensors.1.units", "sensors.1.sensor_type", "sensors.1.meter_style",
                      "sensors.1.factor", "sensors.1.initial_meter_read"]
  filter = (search) => {
    const arrData = this.state?.report.slice(0);
    if (search.length === 0) {
      const display = formatTable (arrData, "device_id", this.props.radioFormat());
      this.setState({filterReport: arrData, formatReport: display});
    }
    else { 
      const usearch = search.toUpperCase();
      const arrFilter = arrData.filter (item => 
        this.filterable.map(key => (item[key]??'').toUpperCase().indexOf(usearch) > -1 ||
             this.transformSearch(item, key, usearch))
             .reduce ((result, current) => result | current))
      const display = formatTable (arrFilter, "device_id", this.props.radioFormat());
      this.setState({filterReport: arrFilter, formatReport: display});
    }
  }
  /*param has .changedInputs[], an array of changes. use that to build an
  * invariant json body.
  * then, for each device that was selected at the time of massedit, construct a URL
  * /sites/devices/{radioid}/sensors/{index}?access_code={siteid}
  * invoke the url with the invariant post body
  */
  async onMassEdit(edits) {
    const postBody = {}
    edits.changedInputs.forEach(item => postBody[item.property] = item.value )
    const ac=siteAccessCode(this.props.getActiveSite());
    const devices = this.currentTable()
    const usings = this.state.massData.filter(item => typeof item === 'string')
    const bulkUrls = []
    usings.forEach(async item => {
      const arrItem = item.split(".")
      const index = Number(arrItem[0])
      const radioId = devices[index].device_id
      const sensor = arrItem[arrItem.length-1]
      bulkUrls.push(urlSensorInfo(radioId,ac, sensor))
    })
    this.bulkSave (postBody, bulkUrls)
  }
  async bulkSave (postBody, urls) {
    this.setState({isLoading: true})
    const apiBody = JSON.stringify(postBody)
    for (let url of urls) {
      try {
        await this.ss.apiSaveData (url, apiBody);
      } catch (err) {
        this.setState({errorMsg: this.ss.getErrorMsg()})
        console.log ("error ", err)
      }
    }
    this.setState({isLoading: false})
    this.refresh()
  }
  parentUpdate(param) {
    if (param === 'battery') {
      const bf = this.state.batteryFormat ? 0 : 1;
      this.setState ({batteryFormat:bf})
    }
    else {  // radio
      const display = formatTable (this.state.filterReport, "device_id", this.props.radioFormat());
      this.setState ({formatReport: display});
    }
  }
  confirmed() {
    this.setState({errorMsg: ''})
    this.refresh();
  }
  onEdit(evt) {
    const btn= clickToNamedClass(evt, "actButton")
    //console.log (btn.className, btn.getAttribute('index'))
    this.setState({deviceToEdit:btn.getAttribute('index'), editModal: true})
  }
  onEditHide(props) {
    if (props.refresh)
      this.refresh()
    this.setState({editModal: false})
  }

  currentTable () {
    const site = this.state.formatReport ?? this.state.filterReport
    return site ? site.filter(dev => this.mdtSelectable(dev)) : site
  }
  sortableTH(name, jsonKey, colSort) {
    const icons = [faSort, faSortUp, faSortDown];
    return <th className="measure-th-sortable" id={jsonKey} key={jsonKey}>
    {name} <FontAwesomeIcon icon={icons[colSort]} color="#888" /></th>
  }
  nonSortableTH(name, jsonKey) {
    return <th className="csv-th" id={jsonKey} key={jsonKey}>{name}</th>
  }
  tableHead() {
    const mainHeads =[{}, {}, {name: "Type", key: "type"}, {name:"Radio Id", key: "device_id"},
                      {name:"Node Id", key: "node_id"}, {name: "Building", key: "building"},
                      {name:"Apt", key: "apt"} ]
    return (<tr className="csv-tr" onClick={this.sort}>
      {mainHeads.map((item, index) => index === 0 ? this.titleRowCheckbox() :
        index ===1 ? this.nonSortableTH("", "ikey") : 
        this.sortableTH(item.name, item.key, this.state.colSort[index]) 
      )}
      <th className="tour-table-head">
      <span className="nestedCol3 colInline" key='util'>Utility</span>
      <span className="nestedCol4 colInline" key="unit">Units</span>
      <span className="nestedCol5 colInline" key='style'>Style</span>
      <span className="nestedCol5 colInline" key='count'>Factor</span>
      <span className="nestedCol5 colInline" key='imr'>IMR</span>
      </th>
      </tr>)
  }
  emptySensors () {
    return (
      <td><table className='nestedTbl'><tbody>
      <tr>
        <td key='n1' className='gridBold gridNarrow'>
          No sensors available</td>
      </tr>
      </tbody></table></td>
    )
  }
  nestedTable(device) {
    const scount = device.sensors.length
    if (scount < 2) 
      return this.emptySensors()
    return (
      <td key="nxt" className="nestd">
        <table className='nestedTbl' key='nest'><tbody>
        {this.nestedTableRow(0, device)}
        {this.nestedTableRow(1, device)}
      </tbody></table></td>
    )
  }
  sensorType (device, index) {
    if (device?.sensors?.length>=index) {
      const baseProp = "sensors."+index+"."
      return nestedProp(device, baseProp+"sensor_type") ?? 'FF'  
    }
    return undefined
  }
  nestedTableRow (index, device) {
    const sensor = this.sensorType (device, index)
    const shown = this.sensorSelected(sensor)
    return (
      <tr>
        {shown ? this.selectedDetails(sensor, index, "sensors."+index+".", device):
          <td key='z'></td>}
      </tr>
    )
  }
  displayName (sensor) {
    return this.sensorSelected (sensor) ? sensorTypeName(sensor) : "Not Using"
  }
  sensorSelected (type) {
    return this.state.activeSensor === sensorTypeName (type)
  }
  selectedDetails(sensor, index, baseProp, device) {
    return (<>
      <td key={'b'+index} className="nestedCol3">
        {MeterTypeDisplay(nestedProp(device, baseProp+'meter_type'))}</td>
      <td key={'c'+index} className="nestedCol4">
        {UnitsDisplay(nestedProp(device, baseProp+'units'))}</td>
      <td key={'d'+index} className="nestedCol5">
        {StyleDisplay(nestedProp(device, baseProp+'meter_style'))}</td>
      <td key={'e'+index} className="nestedCol5">
        {parseFloat(nestedProp(device, baseProp+'factor'))}</td>
      <td key={'f'+index} className="nestedCol5">
        {nestedProp(device, baseProp+'initial_meter_read')}</td>
      </>
    )
  }
  deviceInfo(device) {
    const apiProps = ["type", "device_id", "node_id", "building", "apt"]
    return (
      <>
      {apiProps.map((item, index) => 
        (<td key={index} id={item}>{device[item]}</td>))}
      </>
    )
  }
  canEdit() {
    return canWrite(cachedPerms(this.props.getActiveSite()))
  }
  mdtSelectable(dev) {
    return this.sensorSelected(this.sensorType(dev, 0)) ||
            this.sensorSelected(this.sensorType(dev, 1))
  }
  sensorSelectable(index) {
    const dev = this.currentTable()
    return this.sensorSelected(this.sensorType(dev[index], 0)) ||
            this.sensorSelected(this.sensorType(dev[index], 1))
  }
  usingSensor () {
    const dev = this.currentTable()
    const pass1 = dev.map((item, index) => {
      const result =[]
      if (this.sensorSelected(this.sensorType(item, 0)))
        result.push(index+".sensors.0")
      if (this.sensorSelected(this.sensorType(item, 1)))
        result.push(index+".sensors.1")
      return result
    })
    const pass2 = pass1.filter(item => item.length > 0)
    return pass2.flat()
  }
  sensorTypeClick (option, type) {
    this.setState ({activeSensor: option, activeType: type})
  }
  selectClick () {
    this.dlgTitle = "Selected "+this.state.activeSensor
    const usings = this.usingSensor()
    const useIndex = usings.map (item => Number(item.split(".")[0]))
    const editIndex = useIndex.filter(item => this.state.arrCheckboxes[item] === true)
    const selUse = editIndex.map(item => usings[useIndex.findIndex(ui=> ui === item)])
    this.setState({massShow: true, massData: selUse})
  }
  massClick () {
    this.dlgTitle = "All "+this.state.activeSensor
    const usings = this.usingSensor()
    this.setState({massShow: true, massData: usings})
  }
  massOver () {
    this.setState({massShow: false, massData: []})
  }
  dispCounts (arrTotal, selected) {
    let using = 0
    let total = 0
    if (Array.isArray(arrTotal) && selected) {
      using = arrTotal.reduce((sum, mdt) => mdt?.sensors[0]?.sensor_type.toUpperCase() === selected ? sum+1 : sum, 0)
      using = arrTotal.reduce((sum, mdt) => mdt?.sensors[1]?.sensor_type.toUpperCase() === selected ? sum+1 : sum, using)
      total = arrTotal.reduce((sum, mdt) => mdt?.sensors[0]?.sensor_type !== 'FF' ? sum+1: sum, 0)
      total = arrTotal.reduce((sum, mdt) => mdt?.sensors[1]?.sensor_type !== 'FF' ? sum+1: sum, total)
    }
    return {using: using, total: total}
  }
  decorator (props) {
    const icon = nameToIcon(props?.apiIcon)
    const classNm = icon?.props?.className ? "measure-icon-td" : "csv-td"
    return <td className={classNm} key="icon" id="i1">{icon}</td>
  }
  showTable() {
    if (this.state.isLoading) {
      return this.state.loader
    }
    if (!this.state.filterReport) {
      return (<TryAgain />)
    }
    if (this.state.filterReport && this.state.filterReport.length === 0) {
      return (<NoResults displayText="No devices found."/>);
    }
    const rawData = this.currentTable()
    const myEdit = this.canEdit() ? this.onEdit : null
    return(
      <div className="table-container">
      <Popup onClose={this.confirmed} popupMsg={this.state.errorMsg} />
      <table className="measure-table" id={this.tableId}>
        <thead>{this.tableHead()}</thead>
        <tbody>
         {rawData.map((dev, index) => isTransceiverRadio(dev, "device_id") ? null :
          <tr className="majorRow" key={"mr"+index}>
            {this.gridCheck({selected:this.state.arrCheckboxes[index], index: index})}
            {this.decorator(dev)}
            {this.deviceInfo(dev)}
            {this.nestedTable(dev)}
            <td><GridAction id='action' index={index} key="actions" onEdit={myEdit} /></td>
          </tr>
        )}
        </tbody>
      </table>
    </div>
    )
  }

  render() {
    try {
      const table = this.currentTable()
      const editData = this.state.deviceToEdit ? table[this.state.deviceToEdit] : undefined
      const counts = this.dispCounts (this.state.formatReport ?? this.state.filterReport, this.state.activeType)
      return (
        <div>
          <div className="control-row">
            <Search onChange={this.filter}>
              <FilterRender />
            </Search>
            <SensorTypeDropdown types={this.sensorTypes} value={this.state.activeSensor} 
              onClick={this.sensorTypeClick}/>
            <span>&nbsp;  {counts.using} of {counts.total} Sensors </span>
            <span className="meter-controls" key="b2"><Button onClick={this.selectClick}>Edit Selected</Button></span>
            <span className="meter-controls" key="b3"><Button onClick={this.massClick}>Edit All</Button></span>
          </div>
          <div className='control-space'>&nbsp;</div>
          <MeterMassEdit show={this.state.massShow} data={this.state.massData} devices={table}
            hide={this.massOver} title={this.dlgTitle} onChange={this.onMassEdit} type={this.state.activeType}/>
          <DeviceEdit {...this.props} deviceId={editData?.device_id} onHide={this.onEditHide}
                    show={this.state.editModal} objMap={this.deviceEditMap} meta={editData}/>
          {this.showTable()}
        </div>
      )
    }
    catch (err) {
      console.log (err)
      return (<TryAgain details={"Measure.render: "+err.toString()} />)
    }
  }
}

//    <span className="meter-controls" key="b1">Using {this.state.activeSensor}</span>
